import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
    Row,
    Col,
} from 'antd'
import {
    LeftOutlined
} from '@ant-design/icons';
import RealtimeAnalysis from './RealtimeAnalysisComponent'
import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';
import './EventAnalysis.css'

const EventAnalysisTemplateView = (props) => {

    const [template, setTemplate] = useState(null)
    const [user, setUser] = useState(null)

    useEffect(() => {
        UIFetchService.get(`/api/v1/sampling/event/template/${props.templateId}`)
            .then((result) => {
                if (result) {
                    setTemplate(result)
                }
            })

        auth.authenticate()
            .then((result) => {
                if (result) {
                    setUser(result)
                    
                }
            })
    }, [props.templateId])

    useEffect(() => {
        if (template != null && user != null) {
            window.CyaLogger?.sendCustomEvent('page_view', '事件分析', 'mould_details_view', {
                event_date: moment().format('YYYY-MM-DD'),
                user_name: user.account,
                mould_name: template.name,
                mould_id: props.templateId
            })
        }
    }, [template, user])

    return <>
        <Row style={{ textAlign: 'left', padding: '0 10px 0 10px', margin: '0 0 10px 0' }}>
            <Col style={{ margin: '0 20px 0 0' }}>
                <span
                    style={{
                        color: 'gray',
                        cursor: 'pointer'
                    }}
                    onClick={() => window.location = '/real_time/event_analysis'}
                ><LeftOutlined /> 返回</span>
            </Col>
            <Col>
                <span>模板详情</span>
            </Col>
        </Row>
        { template != null && user != null ? 
        <>
            <Row justify='left' style={{margin: '40px 30px 20px 20px'}}>
                <Col style={{marginTop: -3}}>
                    <span style={{fontWeight:700, fontSize: 18}}>{template.name}</span>
                </Col>
                <Col flex="200px">
                    <span>创建人：{template.creator}</span>
                </Col>
                <Col flex="200px">
                    <span>数据更新时间：{moment(template.dataUpdatedAt).format('YYYY-MM-DD')}</span>
                </Col>
            </Row>
            <div style={{ 
                    margin:'20px 15px 20px 15px', 
                    border: '1px solid #eee',
                    padding: '20px 10px',
                    boxShadow: '5px 5px 5px #ccc'
                }}>

                <RealtimeAnalysis user={user} template={template} /> 
            </div>
        </>
        : null }
    </>
}


export default EventAnalysisTemplateView